import template from './sw-cms-preview-product-description-reviews.html.twig';
import './sw-cms-preview-product-description-reviews.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
